export { default as Sketch } from './Sketch';
export { default as SketchProps } from './SketchProps';
export { default as FrameData } from './FrameData';
export { default as Config } from './Config';
export {
  default as Params,
  Parameter,
  MultiSelectOptions,
  RangeOptionsObject,
} from './Params';
export { default as Palette } from './Palette';

export { PaletteType, ConfigInput } from './Config';
